import { useRef, Fragment } from 'react';
import ReactToPrint from 'react-to-print';

import PrintPreview from './PrintPreview';

const Print = (props) => {
  const ref = useRef();
  const { title, form, options } = props;

  return (
    <Fragment>
      <ReactToPrint
        trigger={() => <span style={{ width: '100%' }}>Print</span>}
        content={() => ref.current}
        onBeforePrint={() => {
          document.title = title;
        }}
      />
      <PrintPreview ref={ref} form={form} options={options} title={title} />
    </Fragment>
  );
};

export default Print;
